import React, {useState, useEffect} from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import { useUser } from "../context/UserContext"


export default function Home() {
    const [loading, setLoading] = useState(true);
    const userContext = useUser();
    useEffect(() => {
        if (userContext){
            setLoading(false);
        };
    }, []);

    if (loading) {
        return <Box sx={{height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress size="15rem"/>
                </Box>;
    }

    return (
        <Box sx={{margin: '50px'}}>
            <Typography variant='h4' fontWeight='bold' color={'text.primary'} >Proctoring</Typography>
            <Typography>
                Eventually, it will be number one proctoring solution in the world
            </Typography>
        </Box>
    );
}
